/**
 * 高亮关键字
 * @param content 需要转义内容
 * @param keyword 关键字
 */
export function highLight({ content, keyword }: {
  content: string;
  keyword: string;
}): string {
  if (!keyword) return content
  const replaceReg = new RegExp(keyword, 'gi')
  // 高亮替换v-html值
  return String(content).replace(
    replaceReg,
    function(str) { return '<span class="highlight">' + str + '</span>' }
  )
}
